import CustomButton from "custom/button/CustomButton";
import { addToCart } from "features/cart/cartSlice";
import { selectCurrentUser } from "features/user/userSlice";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function AddToCartButton({
  id,
  imageUrl,
  name,
  description,
  price,
  category,
}) {
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);
  const navigate = useNavigate();

  const handleCartAdd = (e) => {
    e.stopPropagation();
    dispatch(
      addToCart({
        id,
        imageUrl,
        name,
        description,
        price,
        category,
      })
    );
  };

  const handleLoginRedirect = (e) => {
    e.stopPropagation();
    navigate("/signin");
  };

  return (
    <CustomButton
      className="text-gray-900 opacity-70 border-0 w-full h-16 2xs:text-xs xs:text-xs sm:text-xs md:text-sm lg:text-lg xl:text-xl transform hover:opacity-100 hover:bg-gray-900 hover:text-white hover:scale-110 transition ease-in-out duration-300 border-none"
      style={{ background: "#318162" }}
      onClick={currentUser ? handleCartAdd : handleLoginRedirect}
    >
      ADD TO CART
    </CustomButton>
  );
}
